module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-21.d1c6aed8.png";